export const MetricsSection = () => {
  return <section className="py-4 md:py-6 pt-1">
      <div className="container mx-auto px-4">
        <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg border border-gray-100 dark:border-gray-700 max-w-4xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            <div className="text-center py-2">
              <div className="text-xl md:text-3xl lg:text-4xl font-bold text-brand-teal mb-1 md:mb-2">+40%</div>
              <div className="text-xs md:text-sm text-gray-600 dark:text-gray-400 leading-tight">Aumento Médio no Faturamento</div>
            </div>
            <div className="text-center py-2">
              <div className="text-xl md:text-3xl lg:text-4xl font-bold text-brand-coral mb-1 md:mb-2">+65%</div>
              <div className="text-xs md:text-sm text-gray-600 dark:text-gray-400 leading-tight">Taxa de Retenção</div>
            </div>
            <div className="text-center py-2">
              <div className="text-xl md:text-3xl lg:text-4xl font-bold text-brand-teal mb-1 md:mb-2">3.2x</div>
              <div className="text-xs md:text-sm text-gray-600 dark:text-gray-400 leading-tight">Mais Indicações</div>
            </div>
            <div className="text-center py-2">
              <div className="text-xl md:text-3xl lg:text-4xl font-bold text-brand-coral mb-1 md:mb-2">ROI</div>
              <div className="text-xs md:text-sm text-gray-600 dark:text-gray-400 leading-tight">Retorno Garantido</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};